import { render } from "./DeleteContactModal.vue?vue&type=template&id=fcc2d618"
import script from "./DeleteContactModal.vue?vue&type=script&lang=js"
export * from "./DeleteContactModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__